import { RequestCharge } from "@app/core";

export class FMSpecialRequestModel {
  specialFMRequestId: string;
  requestStatusName: string;
  requestStatusId: number;
  requestId: number;
  requestNumber: string;
  requestCompeletionDate: string;
  requestClassificationName: string;
  CAFMRequestNumber: string;
  companyName: string;
  requestorName: string;
  officeConfigurationIssueList: string[];
  facaseCleaningIssueList: string[];
  officeConfigurationOther :string ;
  officeConfigurationDetails :string ;
  facadeCleaningOther :string ;
  facadeCleaningDetails :string ;
  cabinetKeyReplacement :string ;
  changeFrom :string ;
  changeTo :string ;
  requestCharges: RequestCharge[];
  chargeAmount: number;
  userCanFeedback: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-special-request.ts